import { render } from "./Canvas.vue?vue&type=template&id=4dd699fa"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"

import "./Canvas.vue?vue&type=style&index=0&id=4dd699fa&lang=css"
script.render = render

export default script